'use strict';

define('vb/action/builtin/navigateToExternalAction',[
  'vb/action/action',
  'vb/helpers/navigate',
],
(Action, Navigate) => {
  /** @typedef {import('vb/action/action').Outcome} Outcome */

  /**
   * Navigate to an external site with given a set of input parameters.
   *
   * @param {Object} options
   * @param {String} options.url     The url to navigate to (required)
   * @param {Object<String, String>} options.params  A map of URL parameters (optional)
   * @param {String} options.hash    The hash entry (optional)
   * @param {String} options.history Effect on the browser history. Allowed value are 'replace' or 'push'.
   *                                 If the value is 'replace', the current browser history entry is replace,
   *                                 meaning that back button will not go back to it. (optional and default is push)
   *
   * Always return {'success'}.
   *
   * An example of entry as seen in a page descriptor:
   *
   * "parameters": {
   *   "url": "'http://mysite/index.html'",
   *   "params": "{ id: $variables.id, name: 'Charles' }",
   *   "hash": "'details'"
   * }
   *
   * @extends Action
   * @category Action
   */
  class NavigateToExternalAction extends Action {
    /**
     * Performs the navigation to an external site based on the provided parameters.
     *
     * @param {Object} parameters - The parameters object containing the navigation details.
     * @returns {Outcome} An outcome object indicating success.
     */
    // eslint-disable-next-line class-methods-use-this
    perform(parameters) {
      Navigate.toUrl(parameters);
      return Action.createSuccessOutcome();
    }
  }

  return NavigateToExternalAction;
});

